import * as Yup from "yup";

export const initialContent = {
  dateOfPurchase: "",
  description: "",
  itemName: "",
  manufacturer: "",
  model: "",
  purchasePrice: "",
  serialNumber: "",
};

export const ContentSchema = Yup.object().shape({
  dateOfPurchase: Yup.string().required("Date of Purchase field name is a required field"),
  description: Yup.string().required("Description field name is a required field"),
  itemName: Yup.string().required("Item Name field name is a required field"),
  manufacturer: Yup.string().required("Manufacturer field name is a required field"),
  model: Yup.string().required("Model field name is a required field"),
  purchasePrice: Yup.string().required("Date of Purchase field name is a required field"),
  serialNumber: Yup.string().required("Serial no field name is a required field"),
});

export const ClaimSchema = Yup.object().shape({
  insuranceCompany: Yup.string().required("insurance is a required field"),
  propertyType: Yup.string().required("Property Type is a required field"),
  dateOfClaim: Yup.string().required("Date of Claim is a required field"),
  dateOfLoss: Yup.string().required("Date of Loss is a required field"),
  claimNumber: Yup.string().required("Claim number is a required field"),
  claimName: Yup.string().required("Claim name is a required field"),
  detailsOfLoss: Yup.string().required("Details of loss is a required field"),
  claimType: Yup.string().required("Claim type is a required field"),
});


export const initialClaim = {
  insuranceCompany: "",
  propertyType: "",
  dateOfClaim: "",
  dateOfLoss: "",
  claimNumber: "",
  claimName: "",
  detailsOfLoss: "",
  claimType: "",
};
